'use client';

import { useMemo } from 'react';
import { getCategoriesQuery, getInfinityArticles } from '@/features/articles';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { Topic } from '.';

interface TopicByCategoryProps {
  category: string;
}

export const TopicByCategory = ({ category }: TopicByCategoryProps) => {
  const {
    isFetching,
    data: infinityArticles,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    getInfinityArticles({
      category,
      key: 'articles',
      limit: 15,
    })
  );

  const { data: categories } = useQuery(getCategoriesQuery());

  const categoryName = categories?.find((item) => item.slug === category)?.name ?? '';

  const articles = useMemo(() => {
    return infinityArticles?.pages.flatMap((page) => page.articles) ?? [];
  }, [infinityArticles]);

  return (
    <Topic
      title={`${categoryName}`}
      articles={articles}
      onFetchMore={fetchNextPage}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
    />
  );
};
